import {
  SET_ROVER,
  SET_FIELD,
  RESET_FIELD_MAP,
  SET_OBSTACLES,
  REMOVE_OBSTACLES,
  RESET_OBSTACLES_MAP,
  SET_POINTS,
  REMOVE_POINTS,
  RESET_POINTS_MAP,
  FIELD_RESULT_PAGE_LOADED
} from './constants/actionTypes';

//ROVER
export const roverAdded = rover => ({
  type: SET_ROVER,
  payload: {
    rover
  }
})

//FIELD
export const fieldAdded = field => ({
  type: SET_FIELD,
  payload: {
    field
  }
})

export const fieldMapReseted = field => ({
  type: RESET_FIELD_MAP
})

//OBSTACLES
export const obstaclesAdded = obstacles => ({
  type: SET_OBSTACLES,
  payload: {
    obstacles
  }
})

export const obstaclesRemoved = id => ({
  type: REMOVE_OBSTACLES,
  payload: {
    id
  }
})

export const obstaclesMapReseted  = obstacles =>({
  type: RESET_OBSTACLES_MAP
})

//POINTS
export const pointAdded = points => ({
  type: SET_POINTS,
  payload: {
    points
  }
})

export const pointRemoved = id => ({
  type: REMOVE_POINTS,
  payload: {
    id
  }
})

export const pointsMapReseted = points =>  ({
  type: RESET_POINTS_MAP
})

export const pointsLoaded = points => ({
  type: FIELD_RESULT_PAGE_LOADED,
  payload: {
    points
  }
})